export class PostEdit {

    private _element: HTMLElement;
    private _control: HTMLElement;
    private _target: HTMLElement = null;
    private _x: number = null;
    private _y: number = null;
    private _elementUnderPoint: any = null;
    private _onFocusChange = e5.Signal.create();
    private _lookup: { [postId: string]: any } = {};
    private _disposables: Disposable[] = [];
    private _ctrlKey: boolean = false;

    constructor() {
        this._element = document.createElement("div");
        this._element.innerHTML = ``;

        this._control = document.createElement("div");
        this._control.classList.add("e5-post-edit__control");
        this._control.innerHTML = `
        <div class="e5-post-edit__control-item" data-action="edit-external">
            <i class="fal fa-pen-to-square"></i>
        </div>
        <div class="e5-post-edit__control-item e5-post-edit__control-item--label"></div>
        <div class="e5-post-edit__control-item e5-post-edit__control-item--id e5-hidden"></div>
        `;

        this._disposables.push(
            e5.event.on(
                {
                    type: "pointerdown",
                    capture: true,
                    passive: false,
                    // scope: document.body,
                    listener: (ev) => {
                        if (!this._control.parentElement) {
                            return;
                        }

                        const bounds = this._control.getBoundingClientRect();
                        const e = ev.event;

                        if (bounds.left <= e.clientX
                            && bounds.right >= e.clientX
                            && bounds.top <= e.clientY
                            && bounds.bottom >= e.clientY) {

                            const hits = this._control.querySelectorAll("[data-action]");

                            hits.forEach((el) => {
                                const bounds = el.getBoundingClientRect();

                                if (bounds.left <= e.clientX
                                    && bounds.right >= e.clientX
                                    && bounds.top <= e.clientY
                                    && bounds.bottom >= e.clientY) {
                                    this.action(el.getAttribute("data-action"));

                                    e.stopImmediatePropagation();
                                    e.preventDefault();
                                }
                            });
                        }
                    }
                }
            ),

            e5.Player.onTick.add(() => {
                this.hitTest();
                this.updateButtonPosition();
            }),

            e5.event.on({
                type: ["mousemove", "mouseenter", "pointerdown"],
                listener: (e) => {
                    this._x = e.event.clientX;
                    this._y = e.event.clientY;
                }
            }),

            e5.event.on({
                type: ["keydown", "keyup"],
                listener: (e) => {

                    if (e.event.type === "keydown") {
                        if (e5.KeyCode.is(e.event, e5.KeyCode.CTRL)) {
                            this._ctrlKey = true;
                        }
                    }

                    if (e.event.type === "keyup") {
                        if (e5.KeyCode.is(e.event, e5.KeyCode.CTRL)) {
                            this._ctrlKey = false;
                        }
                    }
                }
            })
        );

        this._onFocusChange.add(() => {
            if (this._target) {
                const postId = this._target.getAttribute("data-e5-edit");
                const idEl = this._control.querySelector(".e5-post-edit__control-item--id");
                idEl.textContent = postId;
                idEl.classList.remove("e5-hidden");
                if (this._lookup[postId] && this._lookup[postId] !== true) {
                    this.setResponse(this._lookup[postId]);
                } else {
                    this.setLabel("");
                }
            }
        });

        this._onFocusChange.debounce(async () => {
            if (this._target) {
                const postId = this._target.getAttribute("data-e5-edit");

                if (this._lookup[postId]) {
                    if (this._lookup[postId] !== true) {
                        this.setResponse(this._lookup[postId]);
                    }
                    return;
                }

                this._lookup[postId] = true;

                const url = e5.Url.params.set("post_id", postId, e5.Plugins.config.editPostInfo);
                const response = await e5.load("json", url);
                this._lookup[postId] = response;

                if (this._target
                    && this._target.getAttribute("data-e5-edit") == postId) {
                    this.setResponse(response);
                }
            }
        }, 200);
    }

    private setResponse(response: any): void {
        this.setLabel(response.post_type_name);
    }

    private setLabel(label: string): void {
        let l = this._control.querySelector(".e5-post-edit__control-item--label");
        if (label) {
            l.innerHTML = `<span>${label}</span>`;
        } else {
            l.innerHTML = `<i class="fas fa-spinner fa-pulse"></i>`;
        }
    }

    private action(action: string): void {
        // console.log("action", action);

        if (action === "edit-external") {
            let url = e5.Url.params.set("post_id", this._target.getAttribute("data-e5-edit"), e5.Plugins.config.editPostRedirect);
            window.open(url, "_edit");
        }
    }

    private hitTest(): void {
        if (this._x === null) {
            return;
        }

        var e = document.elementFromPoint(this._x, this._y);

        if (this._elementUnderPoint === e) {
            return;
        }
        this._elementUnderPoint = e;
        if (this._elementUnderPoint) {

            // if (this._elementUnderPoint.classList.contains("e5-post-edit__control")) {
            //     return;
            // }

            var p = this._elementUnderPoint;
            while (p) {
                var id = p.getAttribute("data-e5-edit");
                if (id) {
                    this.focus(p as any);
                    return;
                }
                p = p.parentElement;
            }
        }
        this.focus(null);
    }

    private focus(element: HTMLElement): void {
        if (this._target == element) {
            return;
        }
        this._target = element;

        if (!this._target) {
            this._control.remove();
            this._onFocusChange.dispatch();
            return;
        }

        this.updateButtonPosition();

        document.body.appendChild(this._control);

        this._onFocusChange.dispatch();
    }

    private updateButtonPosition(): void {
        if (!this._target) {
            return;
        }

        const boundsControl = this._control.getBoundingClientRect();
        const boundsTarget = this._target.getBoundingClientRect();

        let x = 0;
        let y = 0;
        if (this._ctrlKey) {
            x = this._x - 12;
            y = this._y - boundsControl.height * 0.5;
        } else {
            x = e5.Calc.clamp(boundsTarget.left, 0, window.innerWidth - boundsControl.width);
            y = e5.Calc.clamp(boundsTarget.top, 0, window.innerHeight - boundsControl.height);
        }

        this._control.style.transform = `translate(${x}px, ${y}px)`;

        if (this._target) {
            if (boundsControl.left <= this._x
                && boundsControl.right >= this._x
                && boundsControl.top <= this._y
                && boundsControl.bottom >= this._y) {
                this._control.classList.add("e5-post-edit__control--hover");
            } else {
                this._control.classList.remove("e5-post-edit__control--hover");
            }
        }
    }

    public dispose(): void {
        this._element.remove();
        this._element = null;
        this._control.remove();
        this._control = null;
        this._target = null;
        this._elementUnderPoint = null;
        this._onFocusChange.dispose();
        this._onFocusChange = null;
        this._lookup = null;
        for (let d of this._disposables) {
            d.dispose();
        }
        this._disposables = null;
    }
}